// import { createApp } from 'vue'
// import { createStore } from 'vuex'
// import _ from 'lodash'

import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      token:'',
      userInfo:{
        groupName : '', //所在分组
        username : '', //账号名
        nickname : '',//真实姓名
        phone : ''//手机号
      },
      permissions:[]
      // userInfo: JSON.parse(sessionStorage.getItem('userInfo'))
      //注：sessionStorage内的userInfo是序列化字符串，需要将其反序列化成对象
    },
    mutations: {
      setToken(state, token) {
        // sessionStorage.setItem('token', token);
        localStorage.setItem('token',token);
        state.token = token;
      },

      removeToken(state){
        // localStorage.removeItem('token');
        localStorage.setItem('token','');
        state.token = ''
      },

      setPermission(state,permissions){
        localStorage.setItem('permissions',JSON.stringify(permissions));
        state.permissions = JSON.stringify(permissions);
      },

      removePermissions(state){
        localStorage.setItem('permissions','');
        state.permissions = ''
      },

      setUserInfo(state,userInfo){
        localStorage.setItem('userInfo',JSON.stringify(userInfo));
        state.userInfo = JSON.stringify(userInfo);
      },
      removeInfo(state, userInfo){
        localStorage.setItem('userInfo','');
        state.userInfo = {}
      },

      SET_USERINFO(state, userInfo) {
        var _userInfo = _.merge({},state.userInfo);
        if (!_.size(_userInfo)) {
          _userInfo = {};
        }

        _.each(userInfo,function(value, key){
          _userInfo[key] = value;
        })

        localStorage.setItem('userInfo', JSON.stringify(_userInfo))
        state.userInfo = _userInfo;

      },
      LOGOUT(state){
        // localStorage.setItem('token', '')
        // sessionStorage.setItem('userInfo', JSON.stringify(''))
        // state.userInfo = {}

        localStorage.clear();
        state.userInfo = {};
        state.token = null;
        state.permissions = [];
      }
    },

    getters: {
      //获取用户基本信息
      getUserInfo(state){
        // return state.userInfo
        if (!_.size(state.userInfo)) {
          var userInfo = {};
          var u = JSON.parse(window.localStorage.getItem('userInfo'));
          if (u) {
            userInfo = u;
          }

          localStorage.getItem('userInfo',JSON.stringify(userInfo));
          state.userInfo = userInfo;

          return userInfo;
        }
        return state.userInfo;
      },

      //获取token
      getToken(state) {
        return state.token;
      }
    },
    actions: {},
    modules: {}
  })




// WEBPACK FOOTER //
// ./src/store/index.js